import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import Input from 'react-toolbox/lib/input'

import styles from './styles.scss'

const ClientFormInput = (props) => {
  const {
    hint,
    type,
    value,
    onChange,
  } = props

  return (
    <Input
      theme={styles}
      hint={hint}
      onChange={onChange}
      type={type}
      value={value}
    />
  )
}

ClientFormInput.propTypes = {
  hint: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}

ClientFormInput.defaultProps = {
  hint: '',
  type: 'text',
  value: '',
}

const withStyle = CSSModules(styles)
export default withStyle(ClientFormInput)
